import { useAppStateSelector } from '../../../../providers/AppStateProvider';
import { selectIsFormValid, selectUseTradeAllocations } from '../../../OMS/NewOrder/OrderSlice';
import { useOrderService } from '../../../OMS/NewOrder/useOrderService';
import type { PreTradeResponseData } from '../../redux/preTradeApi';
import { hasPreTradeRelevantChanges } from './hasPreTradeRelevantChanges';

/**
 * Compares current order form request payload with a pre-trade scenario's NewOrderSingle.
 * @returns true if any non-exempt order-affecting field differs from the pre-trade scenario's NOS.
 */
export function useOrderRequestChanged(scenario: PreTradeResponseData | undefined): boolean {
  const isFormValid = useAppStateSelector(selectIsFormValid);
  const useTradeAllocations = useAppStateSelector(selectUseTradeAllocations);
  // Subscribe to form changes; orderService reads form state internally from the store.
  useAppStateSelector(state => state.order.form);
  const orderService = useOrderService();

  if (!scenario) {
    return false;
  }

  // Fail closed if form is currently invalid.
  if (!isFormValid) {
    return true;
  }

  // Generate an order request based on current order form to compare against
  const orderRequest = orderService.getOrderRequestForPreTrade(useTradeAllocations);

  // Fail closed when we cannot build a request from current form state.
  if (!orderRequest) {
    return true;
  }

  return hasPreTradeRelevantChanges(orderRequest, scenario.NewOrderSingle);
}
